export const cohortsDropdown = ['N/A', 'Winter 2020', 'Spring 2020', 'Summer 2020', 'Fall 2020'];
